async function getPreviousSubscriptions() {
    if (sensePathApp.authData) {
        const docRef = await firestore
            .collection('customers')
            .doc(sensePathApp.authData.uid)
            .collection('subscriptions');
        const snap = await docRef.get();
        if (snap.empty) {
            sensePathApp.firstYearDiscount = true;
        }
    }
}

async function openCheckout(price) {
    toggleLoading(true);
    try {
        const docRef = await firestore
            .collection('customers')
            .doc(this.authData.uid)
            .collection('checkout_sessions')
            .add({
                promotion_code: sensePathApp.firstYearDiscount && "promo_1PxSZKG6qftjPD9DJafGseVJ",
                price: price,
                success_url: window.location.origin,
                cancel_url: window.location.origin
            });
        // Wait for the CheckoutSession to get attached by the extension
        docRef.onSnapshot((snap) => {
            const { error, url } = snap.data();
            if (error) {
                // Show an error to your customer and
                // inspect your Cloud Function logs in the Firebase console.
                alert(`An error occured: ${error.message}`);
            }
            if (url) {
                // We have a Stripe Checkout URL, let's redirect.
                window.location.assign(url);
            }
        });
    } catch (e) {
        console.error(e);
        toggleLoading(false);
    }
}

async function openPortal() {
    toggleLoading(true);
    try {
        const functionRef = firebase
            .app()
            .functions('europe-west2')
            .httpsCallable('ext-firestore-stripe-payments-createPortalLink');
        const { data } = await functionRef({
            returnUrl: window.location.origin,
            locale: "auto" // Optional, defaults to "auto"
        });
        window.location.assign(data.url);
    } catch (e) {
        console.error(e);
        toggleLoading(false);
    }
}

function getPrices() {
    // Getting prices manually for now as users reporting issues with the dropdown
    sensePathApp.products = JSON.parse(JSON.stringify(prices));

    // firestore.collection('products')
    //     .where('active', '==', true)
    //     .orderBy('role')
    //     .get()
    //     .then(async function (querySnapshot) {
    //         const productPromises = querySnapshot.docs.map(async (doc) => {
    //             const product = {
    //                 name: doc.data().name,
    //                 profile_limit: doc.data().role,
    //                 prices: {
    //                     yearly: { id: null, amount: null },
    //                     monthly: { id: null, amount: null }
    //                 }
    //             };
    //             const priceSnap = await doc.ref.collection('prices').where('active', '==', true).where('type', '==', 'recurring').get();
    //             priceSnap.docs.forEach((priceDoc) => {
    //                 if (priceDoc.data().interval === 'year') {
    //                     product.prices.yearly.id = priceDoc.id;
    //                     product.prices.yearly.amount = priceDoc.data().unit_amount;
    //                 } else {
    //                     product.prices.monthly.id = priceDoc.id;
    //                     product.prices.monthly.amount = priceDoc.data().unit_amount;
    //                 }
    //             });
    //             return product; // Return the product to be collected in the Promise.all
    //         });

    //         const productsArray = await Promise.all(productPromises); // Wait for all products to be created
    //         productsArray.sort((a, b) => a.profile_limit - b.profile_limit); // Sort using profile_limit
    //         sensePathApp.products = productsArray; // Assign the sorted array to sensePathApp.products
    //     })
    //     .catch((error) => {
    //         console.error("Error fetching products: ", error);
    //         sensePathApp.products = prices;
    //     });
}

const prices = [
    {
        "name": "Up to 5 Profiles",
        "profile_limit": 5,
        "prices": {
            "yearly": {
                "id": "price_1PxS7WG6qftjPD9DptHuCLzC",
                "amount": 15000
            },
            "monthly": {
                "id": "price_1PxS7WG6qftjPD9DOPNyQu0c",
                "amount": 1500
            }
        }
    },
    {
        "name": "Up to 10 Profiles",
        "profile_limit": 10,
        "prices": {
            "yearly": {
                "id": "price_1PxS7aG6qftjPD9DwVsphCyu",
                "amount": 30000
            },
            "monthly": {
                "id": "price_1PxS7aG6qftjPD9DeBmHYSvb",
                "amount": 3000
            }
        }
    },
    {
        "name": "Up to 15 Profiles",
        "profile_limit": 15,
        "prices": {
            "yearly": {
                "id": "price_1QIBinG6qftjPD9DqINpXn3J",
                "amount": 45000
            },
            "monthly": {
                "id": "price_1QIBiKG6qftjPD9DtWZv61wS",
                "amount": 4500
            }
        }
    },
    {
        "name": "Up to 20 Profiles",
        "profile_limit": 20,
        "prices": {
            "yearly": {
                "id": "price_1QIBkmG6qftjPD9DFMxyH307",
                "amount": 60000
            },
            "monthly": {
                "id": "price_1QIBkbG6qftjPD9DBXAgqSSJ",
                "amount": 6000
            }
        }
    },
    {
        "name": "Up to 25 Profiles",
        "profile_limit": "25",
        "prices": {
            "yearly": {
                "id": "price_1PxS7cG6qftjPD9Ddaj1C3vg",
                "amount": 75000
            },
            "monthly": {
                "id": "price_1PxS7cG6qftjPD9DDmTyr7xK",
                "amount": 7500
            }
        }
    },
    {
        "name": "Up to 30 Profiles",
        "profile_limit": "30",
        "prices": {
            "yearly": {
                "id": "price_1QIBokG6qftjPD9DZ7uXoRSq",
                "amount": 90000
            },
            "monthly": {
                "id": "price_1QIBoWG6qftjPD9DgdRqHs4E",
                "amount": 9000
            }
        }
    },
    {
        "name": "Up to 35 Profiles",
        "profile_limit": "35",
        "prices": {
            "yearly": {
                "id": "price_1QIBpcG6qftjPD9DpUQI7Aym",
                "amount": 105000
            },
            "monthly": {
                "id": "price_1QIBpPG6qftjPD9DbyPIe0ua",
                "amount": 10500
            }
        }
    },
    {
        "name": "Up to 40 Profiles",
        "profile_limit": "40",
        "prices": {
            "yearly": {
                "id": "price_1QIBqCG6qftjPD9DGTdfAE82",
                "amount": 120000
            },
            "monthly": {
                "id": "price_1QIBq0G6qftjPD9Dg8KzF4nO",
                "amount": 12000
            }
        }
    },
    {
        "name": "Up to 45 Profiles",
        "profile_limit": "45",
        "prices": {
            "yearly": {
                "id": "price_1QIBqoG6qftjPD9DriOG5tnJ",
                "amount": 135000
            },
            "monthly": {
                "id": "price_1QIBqbG6qftjPD9DsmocBYjJ",
                "amount": 13500
            }
        }
    },
    {
        "name": "Up to 50 Profiles",
        "profile_limit": "50",
        "prices": {
            "yearly": {
                "id": "price_1PxS7dG6qftjPD9DJY5dadNZ",
                "amount": 150000
            },
            "monthly": {
                "id": "price_1PxS7dG6qftjPD9DtDs4ML1x",
                "amount": 15000
            }
        }
    },
    {
        "name": "Up to 55 Profiles",
        "profile_limit": "55",
        "prices": {
            "yearly": {
                "id": "price_1QIYp5G6qftjPD9Dy0J537xw",
                "amount": 165000
            },
            "monthly": {
                "id": "price_1QIYosG6qftjPD9Dsvrlnnhn",
                "amount": 16500
            }
        }
    },
    {
        "name": "Up to 60 Profiles",
        "profile_limit": "60",
        "prices": {
            "yearly": {
                "id": "price_1QJIdDG6qftjPD9DaVhtSBVT",
                "amount": 180000
            },
            "monthly": {
                "id": "price_1QJIcxG6qftjPD9DwLSpnBS4",
                "amount": 18000
            }
        }
    },
    {
        "name": "Up to 65 Profiles",
        "profile_limit": "65",
        "prices": {
            "yearly": {
                "id": "price_1QJIdtG6qftjPD9DDtYI3g4w",
                "amount": 195000
            },
            "monthly": {
                "id": "price_1QJIdfG6qftjPD9Di9TZNCeY",
                "amount": 19500
            }
        }
    },
    {
        "name": "Up to 70 Profiles",
        "profile_limit": "70",
        "prices": {
            "yearly": {
                "id": "price_1QJIeWG6qftjPD9Dsj6E7Yag",
                "amount": 210000
            },
            "monthly": {
                "id": "price_1QJIeIG6qftjPD9DkI4QfGaA",
                "amount": 21000
            }
        }
    },
    {
        "name": "Up to 75 Profiles",
        "profile_limit": "75",
        "prices": {
            "yearly": {
                "id": "price_1QJIfhG6qftjPD9DHWQzuRwH",
                "amount": 225000
            },
            "monthly": {
                "id": "price_1QJIfTG6qftjPD9DIQD9ekkw",
                "amount": 22500
            }
        }
    },
    {
        "name": "Up to 80 Profiles",
        "profile_limit": "80",
        "prices": {
            "yearly": {
                "id": "price_1QJIgIG6qftjPD9Di0SO4qJQ",
                "amount": 240000
            },
            "monthly": {
                "id": "price_1QJIg4G6qftjPD9DpPB7OHKo",
                "amount": 24000
            }
        }
    },
    {
        "name": "Up to 85 Profiles",
        "profile_limit": "85",
        "prices": {
            "yearly": {
                "id": "price_1QJIgxG6qftjPD9DxlNBWR4R",
                "amount": 255000
            },
            "monthly": {
                "id": "price_1QJIgmG6qftjPD9DMQW8hnZQ",
                "amount": 25500
            }
        }
    },
    {
        "name": "Up to 90 Profiles",
        "profile_limit": "90",
        "prices": {
            "yearly": {
                "id": "price_1QJIhjG6qftjPD9DObOBJLjp",
                "amount": 270000
            },
            "monthly": {
                "id": "price_1QJIhPG6qftjPD9DoW3pH5wa",
                "amount": 27000
            }
        }
    },
    {
        "name": "Up to 95 Profiles",
        "profile_limit": "95",
        "prices": {
            "yearly": {
                "id": "price_1QJIiQG6qftjPD9D4rmULX7F",
                "amount": 285000
            },
            "monthly": {
                "id": "price_1QJIi9G6qftjPD9D8xeQk0kj",
                "amount": 28500
            }
        }
    },
    {
        "name": "Up to 100 Profiles",
        "profile_limit": "100",
        "prices": {
            "yearly": {
                "id": "price_1QJIj1G6qftjPD9DnzoBdhWQ",
                "amount": 300000
            },
            "monthly": {
                "id": "price_1QJIioG6qftjPD9Diz0bjyaq",
                "amount": 30000
            }
        }
    }
];